import React, { Component } from 'react';
import connect from './store';
import Task from './Task';
import Calendar from './Calendar';
import Header from './Header';
import block from 'bem-cn-lite';
import Tooltip from '../Components/InfoTooltip';
import { I18n } from 'react-i18next';


const b = block('Gantt');
const leftLimit = 2900;
const rightLimit = - 2200; 
class GanttChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            moving: false
        }
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
    }
    onMouseUp(e) {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        this.currentPosition = e.pageX;
        this.setState({isMoving: false});
    }
    onMouseDown(e) {
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        this.currentPosition = e.pageX;
        this.setState({isMoving: true});
    }
    onMouseMove(e) {
        if(!this.state.isMoving) return false;
        const delta = e.pageX - this.currentPosition
        if(
            (this.props.scrollOffset + delta < leftLimit && delta > 0)
            || (this.props.scrollOffset + delta > rightLimit && delta <= 0)
        ){
            this.props.setGlobalState({
                scrollOffset: this.props.scrollOffset + delta
            });
        }
        this.currentPosition = e.pageX;
    }
    render() {
        const { tasks, tooltips } = this.props;
        return (

            <I18n ns={ ['customWorkflow'] }>
            {
                (t) => (
                    <div
                        className={b({grabbing: this.state.isMoving})}
                        onMouseDown={this.onMouseDown.bind(this)}
                        style={{ fontSize: '13px' }}
                    >
                        <Tooltip text={tooltips[0] ? tooltips[0].text : false} />
                        <Header header={t('gantt:title')} />
                        <div
                            className={b('pane')}
                            style={{
                                left: this.props.scrollOffset,
                            }}
                        >
                            <Calendar />
                            <div className={b('task_wrapper')}>
                                <div className={b('task_container')}>
                                    {tasks.map((task, index) => <Task {...task} key={index} index={index} />)}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            </I18n>
            
        );
    }
}

export default connect(GanttChart);
